import { WebPlugin } from '@capacitor/core';
import { UpdateStatus } from './definitions';
const options = {
    minorMandatory: 2,
    patchMandatory: 4,
    splitCount: 2
};
export class UpdateManagerWeb extends WebPlugin {
    verifyStatus(_ = options) {
        return Promise.resolve({
            status: UpdateStatus.Unnecessary,
            versionApp: '1.0.0',
            versionStore: '0.0.0'
        });
    }
}
//# sourceMappingURL=web.js.map